// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aime_c01e1a', '__aime_Fallback_c01e1a'"},"className":"__className_c01e1a","variable":"__variable_c01e1a"};